import React, { Component } from 'react';
import { Modal, ModalClose, ModalBody } from 'react-modal-bootstrap';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import mask from '../../../assets/images/play_icon.png';
import './index.css';
import YouTube from 'react-youtube';
import ModalWindow from '../ModalWindow';
import $ from 'jquery';

export default class Videos extends Component {

	constructor(props) {
		super(props);
		let data = { title: 'wideos', videos: [], ...props.data };
		this.state = {
			open: false,
			showPlayButton: true,
			showGalleryPlayButton: false,
			showFullscreenButton: true,
			showGalleryFullscreenButton: false,
			currentVideo: 0,
			player: [],
			data: data,
			number: 0
		};
		//console.log('Video: ', this.state);
		this.openLightbox = this.openLightbox.bind(this);
		this._renderVideo = this._renderVideo.bind(this);
		this._onSlide = this._onSlide.bind(this);
		this._onReady = this._onReady.bind(this);
	}


	state = {
		isOpen: false
	};

	openModal = (event) => {
		//console.log(event.target);
		this.setState({ isOpen: true });
	};

	openLightbox(index, event) {
		event.preventDefault();
		this.setState({
			currentVideo: index,
			isOpen: true,
			number: this.state.number + 1
		});
	};

	hideModal = (event) => {
		//console.log('closes');
		this.setState({ isOpen: false });
		this.stopPlay();
	};

	closeModal() {
		//console.log("closemodal");
		this.setState({ isOpen: false, player: [] });
		this.stopPlay();
	}

	_renderVideo(item) {
		const opts = {
			height: '480',
			width: '100%',
			playerVars: {
				controls: 1,
				modestbranding: 1,
				loop: 1
			}
		};
		return (
			<div className='videos image-gallery-image'>
				<div className='videos video-wrapper'>
					<YouTube
						className="video"
						videoId={item.pathname}
						opts={opts}
						onReady={this._onReady}
						controls
					/>
				</div>
				{item.desc &&
					<span className="images image-gallery-description">{item.desc}</span>
				}
			</div>
		);
	}


	_onReady(event) {
		this.setState({
			player: event.target
		});
	};

	_onSlide(e) {
		this.stopPlay();
	}

	stopPlay() {
		$('.video').each(function () {
			this.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
		});
	}

	handleImageLoad(event) {
		//console.log('Image loaded ', event.target)
	}

	render() {

		var openLightbox = this.openLightbox;
		var current = this.state.currentVideo;

		return (
			<div className="videos row">
				<div className="videos col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<div className="videos title">{this.state.data.title}</div>
				</div>
				<div className="videos col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<div className='videos row'>
						{
							this.state.data.videos.map(function (object, i) {
								let backgroundImage = { backgroundImage: 'url(' + object.thumbnail + ')', top: 0, right: 0, left: 0, bottom: 0, position: 'absolute', flex: 1, backgroundPosition: 'center', backgroundSize: 'cover', zIndex: 1 };
								return (
									<div className="videos item col-xs-12 col-sm-4 col-md-3 col-lg-3" key={i}>
										<div className='videos multimedia_button' onClick={(e) => openLightbox(i, e)}>
											<div style={backgroundImage}></div>
											<div className="videos mask">
												<div className="videos mask-img">
													<img src={mask} alt='' />
												</div>
											</div>
										</div>
									</div>
								);
							})
						}
					</div>
				</div>
				<Modal isOpen={this.state.isOpen} onRequestHide={this.hideModal}>
					<button type="button" className="videos player_button_close" onClick={this.hideModal}>X</button>
					<ModalBody>
						<ImageGallery
							key={this.state.number}
							items={this.state.data.videos}
							startIndex={current}
							slideInterval={1000}
							showPlayButton={false}
							showFullscreenButton={false}
							onImageLoad={this.handleImageLoad}
							onSlide={this._onSlide}
							renderItem={this._renderVideo} />
					</ModalBody>
				</Modal>
			</div>
		);

	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/Videos/index.js